export let nativeIntersectionObserverSupported = true;

/**
 * Support detection ripped from the polyfill. See:
 * https://github.com/w3c/IntersectionObserver/blob/e6262484ebf72445b9ccb895a4e68983170d02f0/polyfill/intersection-observer.js#L19-L34
 */
if (
  !(
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  )
) {
  nativeIntersectionObserverSupported = false;
  import('intersection-observer'); // will an async import work?
}

export const IntersectionObserver = window.IntersectionObserver;
